import { Button, Input, message, Modal, Select, Space } from "antd";
import { useState } from "react";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";

function SelectStationModal({
  open = false,
  onUpdated = () => {},
  onCancel = () => {},
  rideId,
  stations = [],
  isStart,
}) {
  const [selectedStation, setSelectedStation] = useState("");

  const handleRideUpdate = async () => {
    let data = {};
    if (isStart) {
      data.start_dock_station = selectedStation;
    } else {
      data.end_dock_station = selectedStation;
    }
    let res = await apiRequest({
      path: apiPaths.rides + "/" + rideId,
      method: "PUT",
      data: data,
    });
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    onUpdated(res);
  };

  return (
    <Modal
      title={`Update Ride ${isStart ? "start" : "end"} Dock Station?`}
      centered
      //   width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <div>
        <div style={{ marginTop: 10 }}>
          Ride{isStart ? " Start " : " End "} Dock Station
        </div>
        <Select
          showSearch
          placeholder="Search and Select Station Number"
          optionFilterProp="children"
          onChange={(value) => {
            setSelectedStation(value);
          }}
          filterOption={(input, option) =>
            (option?.label ?? "").includes(input)
          }
          options={stations.map((item) => ({
            value: item._id,
            label: item.name,
          }))}
        />
      </div>
      <Space
        style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}
      >
        <Button onClick={onCancel}>Cancel</Button>
        <Button type="primary" onClick={handleRideUpdate}>
          {"Update"}
        </Button>
      </Space>
    </Modal>
  );
}

export default SelectStationModal;
